import React, { useEffect, useRef, useState } from "react";
import {
  ChevronLeftIcon,
  PaperAirplaneIcon,
} from "@heroicons/react/24/outline";
import logo from "../assets/Logo icon.png";
import { useDispatch, useSelector } from "react-redux";
import { updateBotMessages } from "../Redux/Actions/dexyActions";
import DOMPurify from "dompurify";
import axios from "axios";

function Bot({ setView, setActiveIcon, setupDetails }) {
  const [message, setMessage] = useState("");
  const dexyData = useSelector((state) => state.dexy);
  const dispatch = useDispatch();
  const [smooth, setSmooth] = useState(false);

  const delays = [0, 0.15, 0.3]; // Delay values for each spinner

  const getSessionId = () => {
    let sessionId = localStorage.getItem("dexkor-chat-widget-session-id");
    if (!sessionId) {
      sessionId = new Date().toISOString();
      localStorage.setItem("dexkor-chat-widget-session-id", sessionId);
    }
    return sessionId;
  };

  const askQueryToDexy = async (query) => {
    if (!query || query === "" || dexyData.loading) {
      return;
    }
    setMessage("");
    try {
      dispatch(
        updateBotMessages(
          { text: query, from: "Customer", createdAt: new Date() },
          true
        )
      );
      const response = await axios.post(
        `${process.env.REACT_APP_CHAT_MICROSERVICE_URL}/dexy/ask-dexy`,
        {
          sessionId: getSessionId(),
          query: query,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      dispatch(
        updateBotMessages(
          { text: response.data.response, from: "Dexy", createdAt: new Date() },
          false
        )
      );
    } catch (error) {
      console.error("Error occurred while asking query to dexy:", error);
    }
  };

  const messagesEndRef = useRef(null);
  const scrollToBottom = (smooth) => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({
        behavior: smooth ? "smooth" : "auto",
      });
    }
  };

  useEffect(() => {
    setSmooth(true);
  }, []);

  useEffect(() => {
    scrollToBottom(smooth);
  }, [dexyData?.messageList]);

  const getRawText = (htmlString) => {
    const doc = new DOMParser().parseFromString(htmlString, "text/html");
    return doc.body.textContent || doc.body.innerText || "";
  };

  const removeQuotedText = (message) => {
    const quotedTextPattern =
      /(?:^On .+ wrote:|^From: .+|^\s*>.*(?:\n|$)|^>.*(?:\n|$))/gms;
    const result = message?.replace(quotedTextPattern, "").trim();

    return getRawText(result);
  };

  return (
    <div className="flex flex-col h-screen">
      <div className="relative mt-4 flex-grow">
        <div>
          <ChevronLeftIcon
            onClick={() => {
              setView("LandingWindow");
              setActiveIcon("home");
            }}
            className="w-5 h-5 text-blue-800 absolute left-3 cursor-pointer"
          />
        </div>
        <div
          style={{
            background: `linear-gradient(90deg, ${
              setupDetails?.widgetCustomizations?.primaryColor || "#4c73de"
            } 0%,  ${
              setupDetails?.widgetCustomizations?.secondaryColor || "#2a4dad"
            } 100%)`,
            backgroundClip: "text",
            color: "transparent",
            fontWeight: "bold",
          }}
          className=" font-semibold text-base mb-4"
        >
          Dexy
        </div>
        <hr></hr>
        <div
          style={{
            overflowY: "auto",
            maxHeight: "62vh",
            width: "100%",
            msOverflowStyle: "none", // For IE and Edge
            scrollbarWidth: "none", // For Firefox
          }}
        >
          <div className="flex flex-col items-center">
            <img src={logo} alt="Brand-icon" className="w-24 h-24" />
            <div className="text-sm font-semibold">Dexy answers instantly</div>
          </div>
          <div className="flex mt-8">
            <img src={logo} alt="Brand-icon" className="w-10 h-10 mt-auto" />
            <div>
              <div className="border rounded-xl font-normal text-xs text-black bg-gray-200 p-3 w-72 text-start">
                Hi, welcome to Dexy,
                <span className="block mt-4">
                  You’re speaking with Dexy AI Agent - I’m here to answer your
                  questions.You can also talk to the team if you need to.
                </span>
              </div>
              <div className="flex justify-start items-center gap-0 mt-2">
                <div className="flex border rounded-e-xl rounded-t-xl font-normal text-xs text-black bg-gray-200 p-2 text-start">
                  <span className="text-xs">How can i help?</span>
                </div>
              </div>
            </div>
          </div>

          {dexyData.messageList &&
            dexyData.messageList
              ?.slice()
              ?.reverse()
              ?.map((msg, index) =>
                msg.from === "Customer" ? (
                  <div
                    key={index}
                    className="flex justify-end ml-[20%] items-center mt-4"
                  >
                    <div
                      style={{
                        background: `linear-gradient(90deg, ${
                          setupDetails?.widgetCustomizations?.primaryColor ||
                          "#4c73de"
                        } 0%,  ${
                          setupDetails?.widgetCustomizations?.secondaryColor ||
                          "#2a4dad"
                        } 100%)`,
                        backgroundClip: "text",
                        color: "transparent",
                      }}
                      className={`font-normal text-sm text-black text-start border p-2 rounded-s-xl rounded-t-xl bg-blue-200 break-words whitespace-normal relative min-w-[6vw] mr-0`}
                    >
                      <span
                        className="pr-14"
                        dangerouslySetInnerHTML={{
                          __html: DOMPurify.sanitize(
                            removeQuotedText(msg.text)
                          ),
                        }}
                      ></span>
                      <span className="text-xs text-gray-500 absolute bottom-1 right-1 whitespace-nowrap">
                        {new Date(msg.createdAt).toLocaleTimeString([], {
                          hour: "2-digit",
                          minute: "2-digit",
                          hour12: true,
                        })}
                      </span>
                    </div>
                  </div>
                ) : (
                  <div key={index}>
                    <div className="flex items-center max-w-[85%]">
                      <img
                        src={logo}
                        alt="Brand-icon"
                        className="w-10 h-10 mt-auto"
                      />
                      <div className="flex justify-start items-center mt-4">
                        <div
                          className={`ml-0 font-normal text-sm text-black text-start border p-2 rounded-e-xl 
                         rounded-t-xl bg-gray-200 break-words whitespace-normal relative min-w-[6vw]`}
                        >
                          <span
                            className="pr-14"
                            dangerouslySetInnerHTML={{
                              __html: DOMPurify.sanitize(
                                removeQuotedText(msg.text)
                              ),
                            }}
                          ></span>
                          <span className="text-xs text-gray-500 absolute bottom-1 right-1 whitespace-nowrap">
                            {new Date(msg.createdAt).toLocaleTimeString([], {
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: true,
                            })}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              )}

          {dexyData.loading && (
            <div className="flex items-center max-w-[85%] mt-4">
              <img src={logo} alt="Brand-icon" className="w-10 h-10" />
              <div
                className="flex space-x-1 ml-0 font-normal text-sm text-black text-start border pt-2 pr-2 pl-2 pb-2 rounded-e-xl 
                         rounded-t-xl bg-gray-200 break-words whitespace-normal relative"
              >
                {delays.map((delay, index) => (
                  <div
                    key={index}
                    className="inline-block h-3 w-3 animate-grow-bounce rounded-full bg-gray-500"
                    style={{ animationDelay: `${delay}s` }}
                    role="status"
                  >
                    <span className="sr-only">Loading...</span>
                  </div>
                ))}
              </div>
            </div>
          )}
          <div ref={messagesEndRef}></div>
        </div>
      </div>

      <div className="relative mb-4">
        <input
          type="text"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder="Ask me anything"
          style={{
            color: setupDetails?.widgetCustomizations?.primaryColor,
          }}
          className="text-xs bg-transparent border border-blue-900 rounded-2xl p-5 pr-12 w-full "
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              askQueryToDexy(message);
              e.preventDefault(); // Prevent newline insertion
            }
          }}
        />

        <div className="absolute inset-y-0 right-0 flex items-center pr-2">
          <PaperAirplaneIcon
            onClick={() => {
              if (!dexyData.loading) {
                askQueryToDexy(message); // Only call handleMessage if loading is false
              }
            }}
            style={{
              color: setupDetails?.widgetCustomizations?.primaryColor,
            }}
            className={`w-6 h-6 mr-2 ${
              dexyData.loading
                ? "text-gray-400 cursor-not-allowed"
                : "text-blue-900 cursor-pointer"
            }`}
          />
        </div>
      </div>
    </div>
  );
}

export default Bot;
